// components
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import RadioButtonCheckedOutlinedIcon from '@mui/icons-material/RadioButtonCheckedOutlined';

// hooks
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

// types
import { EmployeeNameFormatTypes } from '../RosterPlan.types';
import { EmployeeNameFormatItemProps } from './EmployeeNameFormatItem.types';

export function EmployeeNameFormatItem({
  colDef,
  hideMenu,
  nameFormat,
  onSelectNameFormat
}: EmployeeNameFormatItemProps) {
  const { t } = useTranslation('common', {
    keyPrefix: 'rosterPlan.dataGrid'
  });
  const apiRef = useGridApiContext();
  if (colDef?.field !== 'employee') return null;

  const onSelect = (
    e: React.MouseEvent<HTMLElement>,
    format: EmployeeNameFormatTypes
  ) => {
    apiRef.current.hideColumnMenu();
    hideMenu?.(e);
    onSelectNameFormat(format);
  };

  const Row = ({
    label,
    format
  }: {
    label: string;
    format: EmployeeNameFormatTypes;
  }) => (
    <MenuItem onClick={(e) => onSelect(e, format)}>
      {nameFormat === format ? (
        <ListItemIcon>
          {/* Note: we use the default MUI icons because it needs to match the default DataGrid design */}
          <RadioButtonCheckedOutlinedIcon fontSize="small" />{' '}
        </ListItemIcon>
      ) : (
        <ListItemIcon>
          <CircleOutlinedIcon fontSize="small" />
        </ListItemIcon>
      )}
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );

  return (
    <>
      <Row label={t('employeeNameFormat.initialsLast')} format="nameCompound" />
      <Row
        label={t('employeeNameFormat.lastInitials')}
        format="nameCompoundSurname"
      />
      <Row label={t('employeeNameFormat.firstLast')} format="nameInformal" />
      <Row
        label={t('employeeNameFormat.lastFirst')}
        format="nameSurnameCompound"
      />
    </>
  );
}
